export default __webpack_public_path__ + "static/activity-audit-d4cb75ffe5bbbca5cd73a1563e71dd19.png";